<template>
  <div id="photo_live_selfie_page">
  <div id="target" ref="target"></div>
</div>
</template>

<script>
export default {
  name: 'PhotoLifeSelfie',
  props: {
    item: {
      type: Object,
      require: false
    }
  },
  data: function () {
    return {
      window: global.window,
      target: null,
      vdAlive: null,
      message: '',
      unmounted: true,
      image: null,
      imageAlive: null
    }
  },
  mounted: function () {
    // Get the reference to the DOM 'target' element
    this.target = this.$refs.target

    // Set the events handlers for the VDAlive events.
    this.target.addEventListener('VDAlive_mounted', this.onVDAliveMounted)
    this.target.addEventListener('VDAlive_mountFailure', this.onVDAliveMountFailure)
    this.target.addEventListener('VDAlive_unmounted', this.onVDAliveUnmounted)
    this.target.addEventListener('VDAlive_faceDetection', this.onVDAliveFaceDetection)
  },
  created: function () {
    this.start()
  },
  beforeRouteLeave (to, from, next) {
    if (!this.unmounted) {
      this.window.destroyVDAliveWidget()
    }
    next()
  },
  methods: {
    start: function () {
      this.message = 'Loading...'
      this.loadScript('/vendor/dasNano/VDAlive.js')
    },
    sdkStart: function () {
      // const jws = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzY2hlbWEiOiJodHRwczovL3ZlcmlkYXMuY29tL2Rhc2ZhY2Uvc2NoZW1hcy9jaGllZi12MC4wLjAuanNvbiIsImlkIjoiZTdhMDY3OGQ0NDgwNDIwN2IxMDFlYzRiYTk0YzQxY2MiLCJ0aW1lc3RhbXAiOiIyMDIwLTAyLTA2VDE3OjIxOjAxLjg1OTYwOCswMTowMCIsImV4cGlyZXMiOiIyMDIwLTAyLTA2VDE3OjUxOjAxLjg1OTYwOCswMTowMCIsImNoYWxsZW5nZSI6eyJjbGFzcyI6InNlcXVlbnRpYWwiLCJhY3Rpb25zIjpbeyJjbGFzcyI6Im1vdmUtaGVhZC1hbmQtYmFjayIsIm5hbWUiOiJhY3Rpb24tMCIsInBhcmFtZXRlcnMiOnsiZGlyZWN0aW9uIjoiYm90dG9tIn19LHsiY2xhc3MiOiJtb3ZlLWhlYWQtYW5kLWJhY2siLCJuYW1lIjoiYWN0aW9uLTEiLCJwYXJhbWV0ZXJzIjp7ImRpcmVjdGlvbiI6InRvcCJ9fV19fQ.QpsohMK6cpXhWbNgHTX-UJcFOUBhY_yfNhF7gUX44j0'
      const gifPath = '/vendor/dasNano/gifs/'
      const gif = 'VDAlive_Smile.gif'
      const VDAlive = this.window.makeVDAliveWidget()
      VDAlive({
        targetSelector: '#target',
        pathModels: '/vendor/dasNano/models/',
        infoAlertShow: true,
        infoModalShow: true,
        reviewImage: true,
        logEventsToConsole: true,
        ngas_images_path: gifPath,
        // aliveChallenge: jws,
        infoUserButtonTextColor: '#f56789',
        infoUserAliveMedia: gif
      })

      this.message = 'VDAlive SDK started!'
    },
    loadScript: function (src) {
      const script = document.createElement('script')
      script.setAttribute('src', src)
      script.setAttribute('type', 'application/javascript')
      script.addEventListener('load', () => this.sdkStart())
      document.head.appendChild(script)
    },
    onVDAliveMounted: function () {
      this.message = 'VDAlive mounted'
      // Unset the unmounted flag
      this.unmounted = false
      this.$emit('mounted')
    },
    // VDAlive SDK fails to mount
    onVDAliveMountFailure: function (data) {
      this.message = data.detail
    },
    // VDAlive SDK is unmounted
    onVDAliveUnmounted: function () {
      // Set the unmounted flag
      this.unmounted = true
      this.message = ''
    },
    // Face image has been taken
    onVDAliveFaceDetection: function (data) {
      // Assign the images to their variables
      this.image = data.detail.image
      this.imageAlive = data.detail.image_alive

      this.$emit('image', data.detail.image)
      this.$emit('image-alive', data.detail.image_alive)
    },
    // CV script fails to load
    onCVLoadError: function () {
      this.message = 'Failed to load/initialize cv.js'
    }
  }
}
</script>

<style lang="scss" scoped>
#photo_live_selfie_page {
  position: relative;
  width: 100%;
  height: 100%;

  #target {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .message {
    width: 800px;
    margin: auto;
    text-align: right;
    color: #cc3131;
    font-size: 13px;
  }

  .images {
    margin-top: 30px;
    display: flex;
    justify-content: space-around;

    .image {
      width: 40%;
      height: 300px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      background-color: #e5e5e5;
      border: 1px solid #ccc;
      border-radius: 6px;
      color: #999;
      font-size: 20px;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
}
</style>
